export const MATERIAL_TYPE_PHYSICAL = 'PHYSICAL';
export const MATERIAL_TYPE_DIGITAL = 'DIGITAL';

export default {
  MATERIAL_TYPE_DIGITAL,
  MATERIAL_TYPE_PHYSICAL
};



// WEBPACK FOOTER //
// ./app/constants/BibConstants.js